// use this only for set time out based delay of inline and external scripts

var activityEvents, script_loaded = !1;if (void 0 === __isPSA) var __isPSA = !1;if (void 0 === uLTS) {var uLTS = new MutationObserver(e => {});uLTS.observe(document.documentElement, {childList: !0, subtree: !0})}

//__isPSA = 1;
//console.log('isPSA', __isPSA)
function loadJSscripts() {
    // script_loaded = !0; 
    // This ensures that loadJSscripts() only runs its logic once, even if triggered multiple times by user interaction events.
    //where script_loaded || (...) is when The || operator checks if script_loaded is false.
    //If it is, it runs the entire grouped expression inside the parentheses.
    // NOTE that the part below is for external iframe and scripts
    script_loaded || (void 0 !== uLTS && uLTS.disconnect(), void 0 !== window.yett && window.yett.unblock(), script_loaded = !0, document.querySelectorAll("iframe[data-src], script[data-src]").forEach(e => {
        let timeout = 0;
        if (e.getAttribute('data-load') == 1) {
            timeout = 500;
        }
        else if (e.getAttribute('data-load') == 2) {
            timeout = 4000;
        }
        setTimeout(function () {
            // datasrc = e.dataset.src >> Retrieves the value of the data-src attribute from the element e >> Stores it in a variable called datasrc.
            // null != (datasrc = ...) >> Checks if datasrc is not null (i.e., the element actually has a data-src value). >> This is a truthy check — if datasrc is null, the rest of the expression is skipped.
            // && (e.src = datasrc, e.removeAttribute('data-src')) >> If the previous check is true, Sets the element’s src attribute to the value of data-src >> Then removes the data-src attribute from the element
            // The comma operator , allows both actions to run in sequence.
            null != (datasrc = e.dataset.src) && (e.src = datasrc, e.removeAttribute('data-src'))
        }, timeout)    }), document.querySelectorAll("link[data-href]").forEach(e => {
        null != (datahref = e.dataset.href) && (e.href = datahref)
    }), document.querySelectorAll("script[type='text/lazyload']").forEach(e => {
        // NOTE that this part is for internal
        let timeout = 0;
        if( navigator.userAgent.match(/(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d\.]+)/) ) {
            if (e.src.includes('global')) {
                timeout = 8000;
            } else {
                timeout = 100;
            }
        } else {
            if (e.getAttribute('data-load') == 1) {
                timeout = 6000;
                //console.log('60000', e)
                //console.log('60000')
            }
        }

        setTimeout(function () {
            //console.log('you are not running USA')
            var t = document.createElement("script");
            for (a = 0; a < e.attributes.length; a++) {
                var r = e.attributes[a];
                t.setAttribute(r.name, r.value)
            }
            t.type = "text/javascript", t.innerHTML = e.innerHTML, e.parentNode.insertBefore(t, e), e.parentNode.removeChild(e)
        }, timeout)}), document.dispatchEvent(new CustomEvent("asyncLazyLoad")), setTimeout(function () {
        document.dispatchEvent(new CustomEvent("loadBarInjector"))
    }, 1e3))
}

// if __isPSA is true attach loadJSscripts() to a list of user interaction events hence ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"].forEach(fun.. . .
// otherwise just run loadJSscripts(); right away

(__isPSA) ? ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"].forEach(function (e) {
    window.addEventListener(e, loadJSscripts, !1)
}) : loadJSscripts();
